import { SegmentPageTemplate } from 'src/components/pages/segment/SegmentPageTemplate';

import { useLowerCarbonFuelsConfig } from './LowerCarbonFuelsConfig';

export const LowerCarbonFuelsPage = () => {
  const { isBundleLoading, config } = useLowerCarbonFuelsConfig();

  return (
    <SegmentPageTemplate config={config} isBundleLoading={isBundleLoading} breadcrumbTitle={config?.heroAsset?.title} />
  );
};
